import React from "react";
import Navbar from "../components/Navbar";
import { Flex } from "antd";
import Sidebar from "../components/Sidebar";

const DashboardTemplate = ({ children }) => {
  return (
    <div>
      <Navbar />
      <Flex>
        <Sidebar />
        {children}
      </Flex>
    </div>
  );
};

export default DashboardTemplate;
